<template>
    <div class="shop-item">
        <div v-for="(item, index) in list.slice(0, previewNum)" :key="index"
             @click="handleClick(item.officialName)"
             :style="{backgroundImage: 'url(' + item.coverImageUrl + ')' }"
             class="marketplace-item">
            <div class="content">
                <div class="track" v-if="false"/>
                <el-image
                    class="logo"
                    :src="item.logoImageUrl"
                    fit="cover"/>
                <h2>{{item.showName}}</h2>
                <div class="tag">
                    <span :areaType="item.shoppingType">{{item.showCity}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MarketplaceItem",
        props: {
            list: { default: [] },
            previewNum: { },
        },
        data() {
            return {
                imgUrl:require('../../../assets/images/img.png')
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {

            handleClick(officialName) {
                this.$router.push({name: 'MarketplaceInfo', params: {"officialName": officialName}});
            }

        }
    }
</script>
<style lang="less" scoped>

</style>
